import { faLock, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import {
  requestOtp,
  useLocalStorage,
  userLoginByOtp,
  useTimer,
} from "../../../core";
import {
  digitsFaToEn,
  phoneNumberValidator,
} from "@persian-tools/persian-tools";
import { ErrorMessage } from "../..";
import { useStyles } from "./styles";
import { useHistory } from "react-router-dom";
import { LoadingButton } from "../../atoms/LoadingButton";
import { Timer } from "../../atoms/Timer";
import { useTheme } from "react-jss";
import { authenticationContext } from "./Authentication";
import { BotContext } from "../../context";

const Register = () => {
  const { cellnum, setCellnum, otpRequested, setOtpRequested } = useContext(
    authenticationContext
  );
  const [user, setUser] = useLocalStorage("userinfo");
  const { config } = useContext(BotContext);
  const [error, setError] = useState("");
  const [otp, setOtp] = useState(undefined);
  const theme = useTheme();
  const styles = useStyles({ theme });
  const history = useHistory();
  const { counter, reset } = useTimer(60);
  const { mutate: mutateRequestOtp, loading: loadingRequestOtp } = useMutation(
    async () => {
      const { data } = await requestOtp(cellnum);
      return data;
    },
    {
      onSuccess(data) {
        if (data?.status) {
          setOtpRequested(true);
          reset();
        } else {
          setError(data?.message);
        }
      },
      onError(error) {
        setError(error);
      },
    }
  );
  const { mutate: mutateUserLoginByOtp, loading: loadingGetApi } = useMutation(
    async () => {
      const { data } = await userLoginByOtp(cellnum, otp);
      return data;
    },
    {
      onSuccess(data) {
        if (data?.status) {
          const { isregister, accessToken } = data.data;
          if (isregister) {
            history.push("/login", {
              message: "شما قبلا ثبت نام کرده اید",
            });
          } else if (accessToken) {
            setUser({
              accessToken,
              cellnum,
              loggedIn: false,
            });

            history.push("/user-info", { cellnum });
          }
        } else {
          setError(data?.message);
        }
      },
      onError(error) {
        setError(error);
      },
    }
  );

  const handleRequestOtp = () => {
    setError("");
    if (!cellnum) {
      setError("شماره موبایل را وارد کنید");
    } else if (!phoneNumberValidator(cellnum)) {
      setError("شماره موبایل معتبر وارد کنید");
      return;
    } else {
      mutateRequestOtp();
      // reset();
      // setOtpRequested(true);
    }
  };
  const validateOtp = () => {
    if (!otp) {
      setError("کد فعالسازی را وارد کنید");
    } else if (otp?.length < 6) {
      setError("کد فعالسازی نامعتبر");
    } else {
      mutateUserLoginByOtp();
    }
  };
  const requestOtpByEnter = (e) => {
    if (e.charCode === 13) {
      e.preventDefault();
      handleRequestOtp();
    }
  };
  const getApiByEnter = (e) => {
    if (e.charCode === 13) {
      e.preventDefault();
      validateOtp();
    }
  };
  useEffect(() => {
    setError("");
  }, [cellnum, otp]);
  const handleOtp = (event) => {
    const shouldSetValue = event.target.value?.length < 7;
    if (shouldSetValue) {
      setOtp(event.target.value);
    }
  };
  return (
    <Form className={styles.form}>
      <span className={styles.login100FormTitle}>ثبت نام</span>
      <div className={styles.content}>
        <div className={styles.inputsContainer}>
          <div
            className={styles.wrapInput100}
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <Form.Control
              value={cellnum}
              className={styles.input100}
              type="number"
              placeholder="شماره موبایل"
              onChange={(e) => setCellnum(digitsFaToEn(e.target.value))}
              onKeyPress={requestOtpByEnter}
            />

            <span className={styles.symbolInput}>
              <FontAwesomeIcon icon={faPhone} />
            </span>
          </div>

          {otpRequested && (
            <div
              className={styles.wrapInput100}
              data-validate="Password is required"
            >
              <Form.Control
                className={styles.input100}
                type="number"
                name="otp"
                placeholder="کد فعال سازی"
                onKeyPress={getApiByEnter}
                onChange={handleOtp}
                autoFocus
                value={otp}
              />

              <span className={styles.symbolInput}>
                <FontAwesomeIcon icon={faLock} />
              </span>
            </div>
          )}
          {otpRequested && (
            <Button
              className={styles.resend}
              onClick={handleRequestOtp}
              disabled={counter > 0}
            >
              {counter > 0 && <Timer {...{ counter }} />}
              <span> ارسال مجدد کد فعالسازی</span>
            </Button>
          )}
        </div>
        <div className={styles.footer}>
          <ErrorMessage>{error}</ErrorMessage>

          <div className={styles.containerLogin100FormBtn}>
            {!otpRequested ? (
              <LoadingButton
                disabled={counter > 0}
                loading={loadingRequestOtp}
                onClick={handleRequestOtp}
              >
                {counter > 0 && <Timer {...{ counter }} />}
                {counter > 0
                  ? "درخواست مجدد کد فعالسازی"
                  : "درخواست کد فعال سازی"}
              </LoadingButton>
            ) : (
              <LoadingButton
                className={styles.registerButton}
                loading={loadingGetApi}
                onClick={validateOtp}
              >
                ثبت نام
              </LoadingButton>
            )}
          </div>

          <div className="text-center p-t-12 d-flex justify-content-between">
            <Link to={"forget-password"} className={styles.linkText}>
              فراموشی کلمه عبور
            </Link>
            <Link to={"login"} className={styles.linkText}>
              ورود
            </Link>
          </div>
        </div>
      </div>
    </Form>
  );
};

export { Register };
